module.exports = __webpack_public_path__ + "img/check_green.ee2e730b.svg";